import {Tag as AntdTag} from 'antd';

const Tag = ({closable, children, ...props}) => (
  <AntdTag
    closable={closable}
    {...props}
  >
    {children}
  </AntdTag>
);

export default Tag;
